import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import DesktopLanding from "./DesktopView/DesktopLanding";

export default function OpeningScreen() {
  const navigate = useNavigate();
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isDesktop) {
    return <DesktopLanding />;
  }

  return (
    <div className="min-h-screen bg-black flex justify-center items-start">
      <div className="w-full max-w-[430px] min-h-screen bg-gradient-to-b from-[#253246] to-[#1e2738] flex flex-col items-center gap-8 text-center px-6 py-10">
        
        <img src="econet.png" className="w-60 mx-auto mt-4" />
        <img src="YoGamesXR.png" className="w-72 mx-auto mt-12" />
        <h2 className="text-white text-3xl font-bold mt-1">Enter a new Reality!</h2>
        <p className="text-gray-300 text-lg mt-1">Unlimited Entertainment</p>

        <div className="w-full">
          <div className="h-auto w-full pt-2 pb-5">
            <img src="goggles.png" className="w-96 mx-auto mt-4" />
          </div>
          <button
            onClick={() => navigate("/login")}
            className="w-[75%] bg-white text-[#1e2738] font-semibold py-6 rounded-xl shadow-md"
          >
            Log In
          </button>
          <button
            onClick={() => navigate("/subscribe")}
            className="w-[75%] border border-gray-400 text-white font-semibold py-6 rounded-xl mt-4"
          >
            Subscribe
          </button>
        </div>

        <p className="text-gray-300 text-xs mt-12 px-6 leading-relaxed">
          By continuing, you have read, understood and agree to be bound by the YoGamezXR service's{" "}
          <span
            onClick={() => navigate("/termsandconditions")}
            className="underline text-cyan-400 hover:text-cyan-300 cursor-pointer font-medium"
          >
            Terms & Conditions
          </span>{" "}
          and FAQ's
        </p>
      </div>
    </div>
  );
}